<div [formGroup]="form">

    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Monofásica Diferimento"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Diferimento ativo. Os percentuais abaixo serão aplicados no diferimento da tributação monofásica."
        descricaoInativo="Diferimento inativo. Ative para informar os percentuais de diferimento de IBS e CBS."
        emptyStateTitulo="Monofásica Diferimento desativado"
        emptyStateDescricao="Ative o diferimento acima para informar os percentuais de diferimento de IBS e CBS.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">schedule</mat-icon>
            <span>Monofásica Diferimento</span>
            <div class="section-title-actions ms-auto">
                <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Diferimento IBS (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pDifIbs">
                    <mat-error>{{ form.get('pDifIbs')?.hasError('min') ? 'O percentual de diferimento do IBS do monofásico deve estar entre 0 e 100.' : 'Informe os percentuais de diferimento do monofásico.' }}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Diferimento CBS (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pDifCbs">
                    <mat-error>{{ form.get('pDifCbs')?.hasError('min') ? 'O percentual de diferimento da CBS do monofásico deve estar entre 0 e 100.' : 'Informe os percentuais de diferimento do monofásico.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
